import { render, staticRenderFns } from "./allotDataCSG.vue?vue&type=template&id=52eea64d"
import script from "./allotDataCSG.vue?vue&type=script&lang=js"
export * from "./allotDataCSG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52eea64d')) {
      api.createRecord('52eea64d', component.options)
    } else {
      api.reload('52eea64d', component.options)
    }
    module.hot.accept("./allotDataCSG.vue?vue&type=template&id=52eea64d", function () {
      api.rerender('52eea64d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/user/role/allotDataCSG.vue"
export default component.exports